import React, { ReactElement } from "react";
import { RefinementListRenderState } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import {
  BarCheckbox,
  BarCheckboxProps
} from "@silversea-ssc/ui-components-react";

export type RenderListItem = RefinementListRenderState["items"][number];

export type DescriptionForItem = (
  item: RenderListItem
) => ReactElement | string | undefined;

export type TransformItems = (items: RenderListItem[]) => RenderListItem[];
export type CounterLabelFunction = (counter: number) => string;

type Props = {
  items: RefinementListRenderState["items"];
  refine: RefinementListRenderState["refine"];
  className?: string;
  backgroundColor?: BarCheckboxProps["variant"];
  descriptionForItem?: DescriptionForItem;
  transformItems: TransformItems;
  counterLabel: CounterLabelFunction;
};

const RefinedListValues: React.FC<Props> = ({
  items,
  className,
  refine,
  descriptionForItem,
  backgroundColor,
  transformItems,
  counterLabel
}) => {
  const transformedItems = transformItems(items);

  return (
    <div className={className}>
      {transformedItems.map((item) => {
        return (
          <RefinedListValue
            key={item.value}
            item={item}
            backgroundColor={backgroundColor}
            onChange={refine}
            descriptionForItem={descriptionForItem}
            counterLabel={counterLabel}
          />
        );
      })}
    </div>
  );
};
type RefinedListValueProps = {
  item: RenderListItem;
  onChange?: (value: string) => void;
  descriptionForItem?: DescriptionForItem;
  backgroundColor?: BarCheckboxProps["variant"];
  counterLabel: CounterLabelFunction;
};
const RefinedListValue: React.FC<RefinedListValueProps> = ({
  backgroundColor,
  item,
  descriptionForItem,
  onChange,
  counterLabel
}) => {
  const description = descriptionForItem ? descriptionForItem(item) : undefined;
  return (
    <BarCheckbox
      key={item.value}
      label={item.label}
      description={description}
      counterLabel={
        item.count > 0 ? counterLabel(item.count).toLowerCase() : undefined
      }
      disabled={!item.isRefined && item.count <= 0}
      checked={item.isRefined}
      // eslint-disable-next-line react/jsx-no-bind
      onChange={(_) => onChange?.(item.value)}
      variant={backgroundColor}
    />
  );
};

export default RefinedListValues;
